import React from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';
import { BREAKPOINT_MD, BREAKPOINT_SM } from 'reactApp/constants/breakpoints';
import { FeatureSelector } from 'reactApp/modules/features/components/FeatureSelector';
import { getFeatureNewContentGrid } from 'reactApp/modules/features/features.selectors';
import { useWindowWidth } from 'reactApp/ui/VirtualList/VirtualList.hooks';

import styles from '../../DataListItemRow.css';
import newStyles from '../../DataListItemRow.new.css';
import { GalleryItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox';
import { Date } from '../Date';
import { Destination } from '../Destination';
import { Download } from '../Download';
import { Favorite } from '../Favorite';
import { ItemName } from '../ItemName';
import { Pic } from '../Pic';
import { Publish } from '../Publish';
import { Gallery } from '../RowFor/Gallery';
import { Size } from '../Size';

const GalleryItem = (props: GalleryItemProps) => {
    const {
        home,
        onCheckboxClick,
        isSelected,
        thumbUrl,
        isVirus,
        ext,
        name,
        favoritesAvailable,
        onFavorites,
        isInFavorites,
        mtime,
        size,
        onDownload,
        isPublic,
        onPublish,
        id,
        storage,
    } = props;
    const path = home === '/' ? 'Облако' : home;
    const windowWidth = useWindowWidth();

    return (
        <FeatureSelector
            selector={getFeatureNewContentGrid}
            variant1={<Gallery {...props} checkboxClassname={newStyles.check} favoriteClassname={newStyles.favoriteAction} />}
            control={
                <>
                    <Checkbox onCheckboxClick={onCheckboxClick} isSelected={isSelected} />
                    <Pic isFolder={false} thumbUrl={thumbUrl} isVirus={!!isVirus} ext={ext || ''} />
                    {!ENABLE_FULL_RESPONSIVE ? (
                        <>
                            <ItemName name={name} ext={ext || ''} id={id} isRenameAvailable={props.renameAvailable} />
                            <Favorite isAvailable={!!favoritesAvailable} isActive={!!isInFavorites} onClick={onFavorites} />
                            <Destination name={path} />
                            <Date date={mtime} />
                            <Size size={size} />
                            <Download onClick={onDownload} ext={ext} size={size} id={id} storage={storage} />
                            <Publish onClick={onPublish} isActive={isPublic} />
                        </>
                    ) : (
                        <>
                            {windowWidth > BREAKPOINT_SM ? (
                                <ItemName name={name} ext={ext || ''} id={id} isRenameAvailable={props.renameAvailable} />
                            ) : (
                                <div className={styles.responsiveNameWrapper}>
                                    <ItemName name={name} ext={ext || ''} id={id} />
                                    <Destination name={path} noOverflow />
                                    <span className={styles.responsiveDateWrapper}>
                                        <Size size={size} />
                                        {!!mtime && <>&nbsp;•&nbsp;</>}
                                        <Date date={mtime} />
                                    </span>
                                </div>
                            )}
                            {windowWidth > BREAKPOINT_MD && (
                                <Favorite isAvailable={!!favoritesAvailable} isActive={!!isInFavorites} onClick={onFavorites} />
                            )}
                            {windowWidth > BREAKPOINT_SM && (
                                <>
                                    <Destination name={path} />
                                    {mtime && <Date date={mtime} />}
                                    <Size size={size} />
                                </>
                            )}
                            <div className={styles.actionsWrapper}>
                                {windowWidth <= BREAKPOINT_MD && (
                                    <Favorite isAvailable={!!favoritesAvailable} isActive={!!isInFavorites} onClick={onFavorites} />
                                )}
                                <Download onClick={onDownload} ext={ext} size={size} id={id} storage={storage} />
                                <Publish onClick={onPublish} isActive={isPublic} />
                            </div>
                        </>
                    )}
                </>
            }
        />
    );
};

export default GalleryItem;
